import React from "react";
import { cn } from "@/lib/utils";

export function EmptyState({ icon: Icon, title, description, action, className, compact = false }) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-xl border border-dashed bg-[color:var(--surface-1)]/40 text-center",
        compact ? "px-6 py-8" : "px-8 py-14",
        className,
      )}
      data-testid="empty-state"
    >
      {Icon ? (
        <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-full border border-[color:var(--border-subtle)] bg-[color:var(--surface-2)] text-[color:var(--accent-cyan)]">
          <Icon className="h-5 w-5" />
        </div>
      ) : null}
      <h3 className="text-base font-semibold text-1">{title}</h3>
      {description ? <p className="mt-1 max-w-md text-sm text-muted-foreground">{description}</p> : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
